import { MARKETPLACES, MARKETPLACE_BRANDING, ENABLED_MARKETPLACES } from './marketplaces';

// ---------------------------------------------------------------------------
// Every public destination, once.
//
// The footer, the navigation bar and the signed-in footer all listed their own
// links, and they had drifted: the marketing footer offered Terms and Privacy
// while the nav did not, neither mentioned Support, and none of them knew about
// pages that exist. A link list copied into three files is three lists that
// disagree.
//
// RULE FOR THIS FILE: every entry must resolve to something real. A footer full
// of headings that lead nowhere is worse than a short footer — it reads as a
// site that is half-built, and on a legal column it reads as a company with
// something to hide. If a page does not exist yet, it does not belong here.
// ---------------------------------------------------------------------------

// Anchors live on the landing page. From any other page they need the leading
// slash or the browser looks for the anchor on the page you are already on.
export const anchor = (prefix, hash) => `${prefix}${hash}`;

export const PRODUCT_LINKS = [
  { hash: '#features', label: 'Features' },
  { hash: '#pricing', label: 'Plans' },
  { to: '/pricing', label: 'Pricing & credits' },
  { to: '/demo', label: 'See a demo' },
  { hash: '#faq', label: 'FAQ' }
];

// The two sides of this marketplace. A supplier and a seller want different
// first pages, and sending both to /register was how a supplier ended up with
// a seller account they could not list from.
export const AUDIENCE_LINKS = [
  { to: '/register', label: 'For sellers' },
  { to: '/vendor/register', label: 'For suppliers' },
  { to: '/pricing', label: 'For agencies' }
];

export const COMPANY_LINKS = [
  { to: '/about', label: 'About us' },
  { to: '/support', label: 'Support' },
  { to: '/contact', label: 'Contact' },
  { to: '/demo', label: 'Demo' }
];

export const LEGAL_LINKS = [
  { to: '/privacy', label: 'Privacy Policy' },
  { to: '/terms', label: 'Terms & Conditions' },
  { to: '/cookies', label: 'Cookie Policy' },
  { to: '/refunds', label: 'Refund Policy' },
  { to: '/disclaimer', label: 'Disclaimer' }
];

// Which marketplaces we may claim, DERIVED from the flag the product actually
// enforces rather than typed out beside it. ENABLED_MARKETPLACES is what the
// server will accept; a marketing page naming anything else is an advert for
// something a seller cannot do.
//
// The footer said "Amazon · Flipkart · Meesho · Myntra" while the export engine
// accepted exactly one of them. The other three are real work in progress —
// their adapters, field maps and templates are all in the codebase — so they
// are named as coming, not removed and not promised.
export const LIVE_MARKETPLACES = ENABLED_MARKETPLACES.map(
  (k) => MARKETPLACE_BRANDING[k]?.label || k
);

export const COMING_MARKETPLACES = MARKETPLACES
  .filter((k) => !ENABLED_MARKETPLACES.includes(k))
  .map((k) => MARKETPLACE_BRANDING[k]?.label || k);

export const NAV_LINKS = [
  { to: '/', label: 'Home' },
  { hash: '#features', label: 'Features' },
  { to: '/pricing', label: 'Pricing' },
  { to: '/demo', label: 'Demo' },
  { hash: '#faq', label: 'FAQ' },
  { to: '/support', label: 'Support' },
  { to: '/about', label: 'About' }
];
